import startCase from 'lodash/startCase';

import type { InsightSummary } from '@/apis/insights';
import { VISION_AI_MIXPANEL_EVENTS } from '@/components/VisionAi/constants';
import { useTrackingStore } from '@/stores/tracking';

interface InsightTrackContext {
  insight: InsightSummary;
}

function buildPayload({ insight }: InsightTrackContext) {
  return {
    insightId: insight.id,
    signalType: startCase(insight.signalType),
    signalSubtype: insight.signalSubtype ? startCase(insight.signalSubtype) : null,
    productAreas: insight.productAreas.split(',').map(startCase),
    headline: insight.headline,
  };
}

export function trackAiInsightSurfaced(ctx: InsightTrackContext): void {
  useTrackingStore().track(VISION_AI_MIXPANEL_EVENTS.AI_INSIGHT_SURFACED, buildPayload(ctx));
}

export function trackAiInsightClicked(ctx: InsightTrackContext): void {
  useTrackingStore().track(VISION_AI_MIXPANEL_EVENTS.AI_INSIGHT_CLICKED, buildPayload(ctx));
}

export function trackAiInsightOpened(ctx: InsightTrackContext): void {
  useTrackingStore().track(VISION_AI_MIXPANEL_EVENTS.AI_INSIGHT_OPENED, buildPayload(ctx));
}

export function trackAiInsightClosed(ctx: InsightTrackContext): void {
  useTrackingStore().track(VISION_AI_MIXPANEL_EVENTS.AI_INSIGHT_CLOSED, buildPayload(ctx));
}
